export default __webpack_public_path__ + "static/media/indep.a52f3ce5.png";